import React from 'react'
import Link from 'gatsby-link'

//  Components
import ThemeList from '../ThemeList/ThemeList.js'
import arrowUrl, { ReactComponent as Arrow } from '../../assets/svg/icon-arrow-right.svg'

//  Styles
import styles from './ThemeNavFooter.module.scss'

const ThemeNavFooter = ( props ) => (
  <div>
    <ThemeList themes={ props.themes } className={ styles.theme__nav } linkClassName={ styles.theme__nav__link } activeClassName={ styles.theme__nav__link__active } includeArrows={true} />
    <Link to="/conclusion" className={ styles.conclusion__link } activeClassName={ styles.conclusion__link__active }>
      <strong><span>Conclusion<Arrow /></span></strong>
    </Link>
  </div>
)

export default ThemeNavFooter


// WEBPACK FOOTER //
// ./src/components/ThemeNavFooter/ThemeNavFooter.js